<template>
  <div>
    <vs-popup :title="$t('ProductSegments')" :active.sync="showModal">
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[{ title: $t('name') }, { title: $t('Action') }]"
      >
        <template slot-scope="{ row }">
          <td style="width: 50%">
            {{ row.name }}
          </td>
          <td style="width: 30%">
            <vs-button
              radius
              color="success"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              @click.prevent="assignSegment(row.id)"
              class="d-inline"
              v-has-permission="permission39"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "",
  props: {
    show: { default: false },
    actualProductId: "",
  },

  data() {
    return {
      gridDataSource: {},
      gridSearchData: {},
      productInfo: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      assignProductInfo: "productSegment/assignProductInfo",
    }),
    assignSegment(segmentId) {
      this.productInfo.segmentId = segmentId;
      this.productInfo.actualProductId = this.actualProductId;
      this.assignProductInfo(this.productInfo).then(() => {});
      this.$emit("finish");
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.gridDataSource = {
          type: "app",
          service: "Sales/api/SegmentQuery",
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    DataGrid,
  },
};
</script>
